"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactScroll = _interopRequireDefault(require("react-scroll"));

var _stickybits = _interopRequireDefault(require("stickybits"));

var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));

require("../css/anchor_menu.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Events = _reactScroll.default.Events,
    scrollSpy = _reactScroll.default.scrollSpy;

var AnchorMenu =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(AnchorMenu, _PureComponent);

  function AnchorMenu(props) {
    var _this;

    _classCallCheck(this, AnchorMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnchorMenu).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateStickyBits", function () {
      if (_this.stickybitsInstance) _this.stickybitsInstance.update();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "syncWidth", function () {
      var _window$getComputedSt = window.getComputedStyle(_this.node.parentElement),
          width = _window$getComputedSt.width;

      if (width !== 'auto' && _this.node.style.width !== width) {
        _this.node.style.width = width;

        (function () {
          return window.getComputedStyle(_this.node).width;
        })();

        _this.updateStickyBits();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectItem", function (selectedItem) {
      _this.setState({
        selectedItem: selectedItem
      });
    });

    _this.state = {
      selectedItem: undefined
    };
    _this.node = null;
    _this.stickybitsInstance = null;
    _this.containerResizeObserver = null;
    _this.resizeObserver = null;
    return _this;
  }

  _createClass(AnchorMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          sticky = _this$props.sticky,
          top = _this$props.top;
      Events.scrollEvent.register('begin');
      Events.scrollEvent.register('end');
      scrollSpy.update();

      if (sticky) {
        this.stickybitsInstance = (0, _stickybits.default)('.vn-anchor-menu', {
          stickyBitStickyOffset: top
        });

        if (this.node) {
          this.containerResizeObserver = new _resizeObserverPolyfill.default(this.updateStickyBits);
          this.containerResizeObserver.observe(this.node.parentElement);
          this.position = this.stickybitsInstance.definePosition();

          if (this.position === 'fixed') {
            this.resizeObserver = new _resizeObserverPolyfill.default(this.syncWidth);
            this.resizeObserver.observe(this.node);
            this.resizeObserver.observe(this.node.parentElement);
          }
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateStickyBits();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Events.scrollEvent.remove('begin');
      Events.scrollEvent.remove('end');
      if (this.stickybitsInstance) this.stickybitsInstance.cleanup();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.containerResizeObserver) this.containerResizeObserver.disconnect();
    }
  }, {
    key: "checkItemSelected",
    value: function checkItemSelected(items) {
      var _this2 = this;

      return _react.default.Children.toArray(items).map(function (item) {
        if (item.type.displayName === 'AnchorMenuItem') {
          var offset = _this2.props.offset;
          var selectedItem = _this2.state.selectedItem;
          var selected = item.props.anchorTo === selectedItem;
          var itemProps = {};
          itemProps = {
            selected: selected,
            selectItem: _this2.selectItem,
            offset: offset
          };

          if (item.props.children !== null) {
            itemProps.children = _this2.checkItemSelected(item.props.children);
          }

          return _react.default.cloneElement(item, itemProps);
        }

        return null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          sticky = _this$props2.sticky;
      var className = (0, _classnames.default)({
        'vn-anchor-menu': true,
        'vn-anchor-menu--fixed': sticky && this.position === 'fixed'
      });
      return _react.default.createElement("ul", {
        className: className,
        ref: function ref(node) {
          _this3.node = node;
        }
      }, this.checkItemSelected(children));
    }
  }]);

  return AnchorMenu;
}(_react.PureComponent);

AnchorMenu.propTypes = {
  children: _propTypes.default.node.isRequired,
  offset: _propTypes.default.number,
  sticky: _propTypes.default.bool,
  top: _propTypes.default.number
};
AnchorMenu.defaultProps = {
  offset: 0,
  sticky: false,
  top: 0
};
AnchorMenu.displayName = 'AnchorMenu';
var _default = AnchorMenu;
exports.default = _default;